import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges, OnChanges } from '@angular/core';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { GridService } from 'app/Shared/Services/grid.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatChipsModule} from '@angular/material/chips';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import { DialogModule } from 'primeng/dialog';
import { UserService } from 'app/Shared/Services/user.service';

@Component({
    selector: 'app-export-to-csv',
    imports: [FormsModule, CommonModule, ButtonModule, MatTooltipModule, MultiSelectModule, MatChipsModule,
        MatFormFieldModule, MatIconModule, DialogModule
    ],
    templateUrl: './export-to-csv.component.html',
    styleUrls: ['./export-to-csv.component.scss']
})
export class ExportToCSVSComponent implements OnInit, OnChanges {
  isVisible: boolean = false;
  @Output() exportToCSVListner: EventEmitter<{isExportMaxRows: boolean,gridColumn: Array<any>}> = new EventEmitter<{isExportMaxRows: boolean,gridColumn: Array<any>}>();
  @Input() gridColumns: any;
  @Input() OptedExportCSVGridColumns: any = [];
  isExportCurrentPage: boolean = false;
  isExportMaxRows: boolean = false;
  isExportAllColumn: boolean = false;
  col: any
  selectedColumns: any = [];
  isExportMaxRowsForSelectedCol: boolean = false;
  isExport1000RowsForSelectedCol: boolean = false;
  sortedGridColumns: any;
  allColumnsList: Array<string> = [];
  constructor(private emitterService: EmitterService, 
              public constantService: ConstantService, 
              public gridService: GridService,
              public UserService:UserService) { 
    this.emitterService.exportToCSVData.subscribe((data) => {
      if (data) {
        this.isExportMaxRows = false;
        this.isExportCurrentPage = false;
        this.isExportMaxRowsForSelectedCol = false;
        this.isExport1000RowsForSelectedCol = false;
        this.isVisible = false;
      }
    })
   
  }

  /* Apply latest upgraded Exportable Grid Columns (E.g. - Finra Exception Summary Screen) */
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["gridColumns"] && changes["gridColumns"].currentValue.length>0 && !changes["gridColumns"].firstChange) {
      this.selectedColumns = [];
      this.col = this.gridService.getGridColumns(changes["gridColumns"].currentValue);
      this.col.forEach((obj:any) => {
        obj.label = this.constantService.capitalize(obj.label);
        obj.header = this.constantService.capitalize(obj.header);
        delete obj.disabled;
        if(changes["OptedExportCSVGridColumns"] && changes["OptedExportCSVGridColumns"].currentValue.length > 0) {
          let hasOptedMenuItem = changes["OptedExportCSVGridColumns"].currentValue.filter((item: any) => item.dbFieldValue.toLocaleLowerCase() === obj.value.toLocaleLowerCase());
          if(Object.keys(hasOptedMenuItem).length > 0) {
            this.selectedColumns.push(obj.value);
          }
        } else {
          this.selectedColumns.push(obj.value);
        }
        this.allColumnsList = [...this.selectedColumns];
      })
      this.sortedGridColumns = this.constantService.sortByKey(this.col, 'label');
    }
  }

  ngOnInit() {
    this.col = this.gridService.getGridColumns(this.gridColumns);
    this.col.forEach((obj:any) => {
      obj.label = this.constantService.capitalize(obj.label);
      obj.header = this.constantService.capitalize(obj.header);
      delete obj.disabled;
      if(this.OptedExportCSVGridColumns.length > 0) {
        let hasOptedMenuItem = this.OptedExportCSVGridColumns.filter((item: any) => item.dbFieldValue.toLocaleLowerCase() === obj.value.toLocaleLowerCase());
        if(Object.keys(hasOptedMenuItem).length > 0) {
          this.selectedColumns.push(obj.value);
        }
      } else {
        this.selectedColumns.push(obj.value);
      }
      this.allColumnsList = [...this.selectedColumns];
    })
    this.sortedGridColumns = this.constantService.sortByKey(this.col, 'label');
  }

  exportToCSV(isExportMaxRows: boolean) {
    if (isExportMaxRows) {
      this.isExportMaxRows = true;
    } else {
      this.isExportCurrentPage = true;
    }
    this.exportToCSVListner.emit({'isExportMaxRows': isExportMaxRows, 'gridColumn': this.gridColumns});
  }

  exportSelectedColumn(isExportMaxRows: boolean) {
    let newGridCol: any[] = [];
    this.selectedColumns.forEach((key:any) => {
      this.gridColumns.forEach((obj:any) => {
        if(this.constantService.capitalize(obj.db_columnname) === this.constantService.capitalize(key)) {
          newGridCol.push(obj);
        } 
      });
    });
    if (isExportMaxRows) {
      this.isExportMaxRowsForSelectedCol = true;
    } else {
      this.isExport1000RowsForSelectedCol = true;
    }
    this.exportToCSVListner.emit({'isExportMaxRows': isExportMaxRows, 'gridColumn': newGridCol});
  }
  onHide() {
    this.selectedColumns = this.allColumnsList;
  }
}